<template>
  <div
    :key="$route.params.artist"
    class="section pt-0"
  >
    <div class="container">
      <h1 class="title">
        {{ artist.name }}
      </h1>

      <b-tabs
        v-model="activeTab"
        position="is-centered"
        class="block"
        type="is-boxed"
        @change="changeTab"
      >
        <b-tab-item label="Chronology">
          <h2 class="title is-4">
            Artists linked to <b>{{ artist.name }}</b>
          </h2>
          <keep-alive>
            <v-timeline
              v-if="$route.params.section == 'chronology'"
              :artist="artist"
            />
          </keep-alive>
        </b-tab-item>
        
        <b-tab-item label="Inspiration">
          <h2 class="title is-4">
            {{ artist.name }}'s inspiration sources across the globe
          </h2>
          <keep-alive>
            <v-chord-artist-source
              v-if="$route.params.section == 'inspiration'"
              :artist="artist"
            />
          </keep-alive>
        </b-tab-item>

        <b-tab-item label="Influence">
          <h2 class="title is-4">
            {{ artist.name }}'s influence across the globe
          </h2>
          <keep-alive>
            <v-chord-artist-target
              v-if="$route.params.section == 'influence'"
              :artist="artist"
            />
          </keep-alive>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>

let sections = [
	"chronology",
	"inspiration",
	"influence",
];

export default {
	components: {
		"v-chord-artist-target": () => import("../components/ChordArtistTarget"),
		"v-chord-artist-source": () => import("../components/ChordArtistSource"),
		"v-timeline": () => import("../components/timeline/Timeline.vue"),
	},
	data () {
		return {
			activeTab: (this.$route.params.section) ? sections.indexOf(this.$route.params.section) : 0
		};
	},
	computed: {
		artist () {
			return this.$store.state.artists[this.$route.params.artist];
		}
	},
	watch: {
		"$route" () {
			this.activeTab = (this.$route.params.section) ? sections.indexOf(this.$route.params.section) : 0;
		}
	},
	methods: {
		changeTab (index) {
			this.$router.push({ name: "artist", params: {artist: this.$route.params.artist, section: sections[index]} });
		}
	}
};
</script>
